import { render, staticRenderFns } from "./GameInfo.vue?vue&type=template&id=785a3388&scoped=true&"
import script from "./GameInfo.vue?vue&type=script&lang=ts&"
export * from "./GameInfo.vue?vue&type=script&lang=ts&"
import style0 from "./GameInfo.vue?vue&type=style&index=0&id=785a3388&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785a3388",
  null
  
)

export default component.exports